import { render, staticRenderFns } from "./LoadingIP.vue?vue&type=template&id=6b5d7208&scoped=true&"
import script from "./LoadingIP.vue?vue&type=script&lang=js&"
export * from "./LoadingIP.vue?vue&type=script&lang=js&"
import style0 from "./LoadingIP.vue?vue&type=style&index=0&id=6b5d7208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d7208",
  null
  
)

export default component.exports